import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {
    BrowserRouter as Router, Switch,
    Route
} from 'react-router-dom'

import { HealthCheck } from './App';
import Chat from '../src/components/Chat';
import Utility from '../src/components/Utility';
import * as serviceWorker from './serviceWorker';
const path = require('path');
const dotenv = require('dotenv');
const ENV_FILE = path.join(__dirname, '.env');
dotenv.config({ path: ENV_FILE });

// 404 pseudo-page
const NotFound = () => {
    return (
        <div>
            <h2>404: Not Found</h2>
        </div>
    )
}

ReactDOM.render(
    <Router>
        <Switch>
            <Route path="/" component={NotFound} exact />
            <Route path="/health" component={HealthCheck} exact />
            <Route path="/cb" component={Chat} />
            <Route path="/secure/cb" component={Chat} />
            
        </Switch>
    </Router>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
